import {ChatAdapter} from '@fnd/timeline'
import {AssistantChatService} from '../../services/AssistantChatService'

export default class AssistantChatAdapter extends ChatAdapter {
  readonly service = AssistantChatService.shared(this.eventBus)
}
